module.exports = __webpack_public_path__ + "img/1HowToUse.2b460405.png";